export default "__VITE_ASSET__e6e44556__"